import { Box, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { useProductsContext } from 'stores/useProducts';
import { sortingCategories } from 'constants/sortingCategories';

import React from 'react';
import { useServerTranslation } from 'hooks/useServerTranslation';

const RELEVANCE_SORT = { field: '_score', order: 'desc', viewValue: 'sort.relevance' };

type ProductSortingProps = { searchValue?: string };

export default function ProductSorting({ searchValue }: ProductSortingProps) {
    const { t } = useServerTranslation();
    const sortBy = useProductsContext((store) => store.sortBy);
    const sorting = useProductsContext((store) => store.sorting);
    const isSearch = !!searchValue && searchValue.trim().length > 0;

    const dynamicSortingCategories = isSearch
        ? [RELEVANCE_SORT, ...sortingCategories]
        : sortingCategories;

    const getSortingValue = (sort: { field: string; order: string }) => `${sort.field}-${sort.order}`;

    const onChangeSort = (event: SelectChangeEvent<string>) => {
        const { value } = event.target;
        const foundSorting = dynamicSortingCategories.find(
            (sort) => getSortingValue(sort) === value,
        );
        if (foundSorting) {
            sortBy(foundSorting);
        }
    };

    return (
        <Box display="flex" justifyContent="space-between" marginBottom={4}>
            <Typography variant="myCustomersBody" component="div" sx={{ textTransform: 'uppercase', fontSize: '0.875rem' }}>
                {t('sort.sort-by')}
                :
            </Typography>
            <Select
                defaultValue={isSearch ? '_score-desc' : 'sortPriority-desc'}
                variant="standard"
                color={sorting ? 'primary' : 'secondary'}
                size="small"
                onChange={onChangeSort}
                value={getSortingValue(sorting ?? (isSearch ? RELEVANCE_SORT : sortingCategories[0]))}
            >
                {
                    dynamicSortingCategories.map((order, index) => (
                        <MenuItem key={index} value={getSortingValue(order)}>
                            {t(order.viewValue)}
                        </MenuItem>
                    ))
                }
            </Select>
        </Box>
    );
}
